export default __webpack_public_path__ + "static/media/portfolio-62.4a8e4b1d.jpg";